import { render } from "./Kraepelin10View.vue?vue&type=template&id=0f498e6c"
import script from "./Kraepelin10View.vue?vue&type=script&lang=js"
export * from "./Kraepelin10View.vue?vue&type=script&lang=js"

import exportComponent from "E:\\2023-1\\sukun\\Sukun-Psikotes-FE-Peserta\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__